import { useContext, useEffect, useMemo, useState } from 'react';

import { SALES_FUNNELS_PATH, WARNING } from '@app/constants';
import { useUserPrint } from '@app/hooks/useUserPrint';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import {
  useGetGlobalFilterFunnelsQuery,
  useListQuery,
} from '@app/services/rtkQuery/SalesFunnels/api';

import type { DefaultOptionType } from 'antd/es/select';

export const useSalesFunnels = () => {
  const { activeBranchId } = useUserPrint();
  const [selectedSalesFunnelId, setSelectedSalesFunnelId] = useState<
    number | null
  >(null);
  const isSalesFunnelsRegistry =
    window.location.pathname.includes(SALES_FUNNELS_PATH);

  const { showNotification } = useContext(NotificationContext);

  const queryHook = isSalesFunnelsRegistry
    ? useListQuery
    : useGetGlobalFilterFunnelsQuery;

  const {
    data: salesFunnelsData,
    error: salesFunnelsError,
    isLoading: isSalesFunnelsListLoading,
  } = queryHook({ ActiveBranchId: activeBranchId }, { skip: !activeBranchId });

  useEffect(() => {
    if (salesFunnelsError) {
      showNotification(handleCatchError(salesFunnelsError), WARNING);
    }
  }, [showNotification, salesFunnelsError]);

  const salesFunnels: Array<DefaultOptionType> = useMemo(
    () =>
      salesFunnelsData?.map(({ Id, Name }) => ({
        value: Id,
        label: Name,
      })) || [],
    [salesFunnelsData]
  );

  const salesFunnelsStages: Array<DefaultOptionType> = useMemo(
    () =>
      selectedSalesFunnelId
        ? salesFunnelsData
            ?.find(({ Id }) => Id === selectedSalesFunnelId)
            ?.Stages?.map(({ Id, Name }) => ({
              value: Id,
              label: Name,
            })) || []
        : [],
    [salesFunnelsData, selectedSalesFunnelId]
  );

  return {
    setSelectedSalesFunnelId,
    salesFunnels,
    salesFunnelsStages,
    isSalesFunnelsListLoading,
  };
};
